import { apiAmplify } from '@/api';
import { useCurrentUser } from '@/models/global/currentUser';
import { useLocalStorage } from '../utils/useLocalStorage';

export const useSignOut = () => {
  const { clearCurrentUser } = useCurrentUser();
  const { removeLocalStorage } = useLocalStorage();
  /**
   * ログアウト
   */
  const signOut = async () => {
    await apiAmplify.auth.signOut();
    removeLocalStorage('App:CurrentUser:CognitoId');
    clearCurrentUser();
    return;
  };
  return { signOut };
};
